import { deepRecreate } from "object-deep-recreate";
import { getStoreKeyModuleValues, getStoreModule } from "./helpers";
/**
 * gets the current state
 * runs it through all the getters
 * updates the gettersValues where needed
 * @param store
 * @param state
 * @param globalGetters
 * @param prevValuesRef
 */
export var calcAndSetGettersValues = function (store, state, globalGetters, prevValuesRef) {
    var getters = getStoreKeyModuleValues(store, 'getters');
    var getterNames = Object.keys(getters);
    if (!getterNames.length)
        return;
    var setter = function (values) {
        var prevValues = prevValuesRef.current;
        getterNames.forEach(function (getterPath) {
            var _a, _b;
            var moduleNames = getterPath.split('/');
            var originalFn;
            var value;
            // alter the state with the logic given in the store config
            if (moduleNames.length === 1) {
                originalFn = (_a = store.getters) === null || _a === void 0 ? void 0 : _a[getterPath];
                value = originalFn(state);
            }
            else {
                var moduleStore = getStoreModule(store, getterPath);
                var moduleState = getStoreModule(state, getterPath);
                var getterName = moduleNames[moduleNames.length - 1];
                originalFn = (_b = moduleStore.getters) === null || _b === void 0 ? void 0 : _b[getterName];
                value = originalFn(moduleState);
            }
            var prevValueStringified = JSON.stringify(prevValues[getterPath]);
            var isChanged = JSON.stringify(value) !== prevValueStringified;
            if (isChanged) {
                values[getterPath] = deepRecreate(value, JSON.parse(prevValueStringified));
            }
        });
        prevValuesRef.current = JSON.parse(JSON.stringify(values));
        return values;
    };
    globalGetters.setState(setter);
};
export var getGetterInitialValue = function (getterName, gettersFns, store) {
    var originalFn = gettersFns[getterName];
    var moduleNames = getterName.split('/');
    var value;
    // alter the state with the logic given in the store config
    if (moduleNames.length === 1) {
        value = originalFn(store.state);
    }
    else {
        var moduleStore = getStoreModule(store, getterName);
        value = originalFn(moduleStore.state);
    }
    return value;
};
export var getGettersInitialValues = function (store) {
    var gettersFns = getStoreKeyModuleValues(store, 'getters');
    var getterNames = Object.keys(gettersFns);
    var result = {};
    if (!getterNames.length)
        return result;
    getterNames.forEach(function (getterName) {
        var value = getGetterInitialValue(getterName, gettersFns, store);
        result[getterName] = value;
    });
    return result;
};
